// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IExpiryDate } from './IExpiryDate';
import {
    IExpiryDateFromJSON,
    IExpiryDateFromJSONTyped,
    IExpiryDateToJSON,
    IExpiryDateToJSONTyped,
} from './IExpiryDate';

/**
 * 
 * @export
 * @interface IReferenceToken
 */
export interface IReferenceToken {
    /**
     * 
     * @type {string}
     * @memberof IReferenceToken
     */
    token_id: string;
    /**
     * 
     * @type {string}
     * @memberof IReferenceToken
     */
    token_provider: IReferenceTokenTokenProviderEnum;
    /**
     * 
     * @type {number}
     * @memberof IReferenceToken
     */
    tsp_id?: IReferenceTokenTspIdEnum;
    /**
     * 
     * @type {IExpiryDate}
     * @memberof IReferenceToken
     */
    expiry_date?: IExpiryDate;
}

/**
* @export
* @enum {string}
*/
export enum IReferenceTokenTokenProviderEnum {
    TRANS_ARMOR = 'TRANS_ARMOR',
    NETWORKS = 'NETWORKS',
    SINGLE_USE_TOKEN = 'SINGLE_USE_TOKEN',
    ENROLMENT_VAULT = 'ENROLMENT_VAULT'
}
/**
* @export
* @enum {string}
*/
export enum IReferenceTokenTspIdEnum {
    NUMBER_400 = 400,
    NUMBER_501 = 501,
    NUMBER_600 = 600,
    NUMBER_300 = 300,
    NUMBER_111 = 111
}


/**
 * Check if a given object implements the IReferenceToken interface.
 */
export function instanceOfIReferenceToken(value: object): value is IReferenceToken {
    if (!('token_id' in value) || value['token_id'] === undefined) return false;
    if (!('token_provider' in value) || value['token_provider'] === undefined) return false;
    return true;
}

export function IReferenceTokenFromJSON(json: any): IReferenceToken {
    return IReferenceTokenFromJSONTyped(json, false);
}

export function IReferenceTokenFromJSONTyped(json: any, ignoreDiscriminator: boolean): IReferenceToken {
    if (json == null) {
        return json;
    }
    return {
        
        'token_id': json['tokenId'],
        'token_provider': json['tokenProvider'],
        'tsp_id': json['tspId'] == null ? undefined : json['tspId'],
        'expiry_date': json['expiryDate'] == null ? undefined : IExpiryDateFromJSON(json['expiryDate']),
    };
}

export function IReferenceTokenToJSON(json: any): IReferenceToken {
    return IReferenceTokenToJSONTyped(json, false);
}

export function IReferenceTokenToJSONTyped(value?: IReferenceToken | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tokenId': value['token_id'],
        'tokenProvider': value['token_provider'],
        'tspId': value['tsp_id'],
        'expiryDate': IExpiryDateToJSON(value['expiry_date']),
    };
}

